export default "__VITE_ASSET__03899bf6__"